import { render, staticRenderFns } from "./MedicationLogEntriesData.vue?vue&type=template&id=e5072550&scoped=true"
import script from "./MedicationLogEntriesData.vue?vue&type=script&lang=js"
export * from "./MedicationLogEntriesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5072550",
  null
  
)

export default component.exports